module.exports = __webpack_public_path__ + "static/youth-activities-9cba63332cca8a66532103795edc0b10.jpg";